import{ $ } from "../../third-party-imports";

export function getCurrentContext()
{
    $('.blogBox .linkText.articleLink').on("click", function (e: any)
    {
        localStorage.setItem('current_context_url', window.location.href);
    });
}
